import { useEffect, useState } from 'react';
import { getInventory, type ApiClient } from '../../../modules/api';

/** One row is enough: the count comes from the page's `total_count`. */
const PROBE_PAGE_SIZE = 1;

/**
 * How many cards the signed-in player holds in the Vault — the number on the
 * header's Vault pill (partner feedback 2026-10-01: a persistent badge with
 * the vault total, not a "new activity" dot).
 *
 * Re-asks every time `isActive` turns true. The caller passes "signed in AND
 * back on the pack view", which covers every way the count changes: a reveal
 * (rip, sell, vault) and the Vault page (sell, ship) both hand control back
 * to the pack view.
 */
export function useVaultCardCount(client: ApiClient, isActive: boolean): number {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!isActive) return;
    let cancelled = false;
    getInventory(client, { per: PROBE_PAGE_SIZE })
      .then((page) => {
        if (!cancelled) setCount(page.totalCount);
      })
      // The badge is a hint, not state the player acts on: a failed check
      // keeps the last known count instead of surfacing an error.
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [client, isActive]);

  return count;
}
